/*
 * Desktop hover menus.
 *
 * padelpoint.ca opens its top-level nav dropdowns on hover. Dawn builds them
 * from <details>/<summary>, which only open on click, and CSS can't set the
 * `open` attribute — so a small pointer handler does it.
 *
 * Guarded by `(hover: hover) and (pointer: fine)` so touch devices keep the
 * tap-to-open behaviour (a hover menu on touch swallows the first tap), and by
 * a desktop breakpoint so the mobile drawer is untouched. Click and keyboard
 * still work exactly as Dawn intends; this only adds hover on top.
 */
(function () {
  var DESKTOP_HOVER = '(hover: hover) and (pointer: fine) and (min-width: 990px)';
  var mq = window.matchMedia(DESKTOP_HOVER);
  var CLOSE_DELAY = 120; // grace period so a diagonal cursor path doesn't snap it shut

  function bind() {
    document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
      if (details.dataset.brandHoverBound) return;
      details.dataset.brandHoverBound = '1';

      var target = details.closest('li') || details;
      var timer;

      target.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        details.setAttribute('open', '');
      });

      target.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      });

      // Top-level items are real links (see header-dropdown-menu.liquid).
      // Desktop: let the click navigate, but stop it toggling the panel shut
      // on the way out. Touch: cancel navigation so the first tap opens the
      // submenu — otherwise a parent tap would jump the visitor off the page
      // before they could reach its children.
      var parentLink = details.querySelector('summary .header__menu-parent-link');
      if (parentLink) {
        parentLink.addEventListener('click', function (event) {
          if (mq.matches) {
            event.stopPropagation();
          } else {
            event.preventDefault();
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Re-bind after theme-editor section reloads.
  document.addEventListener('shopify:section:load', bind);
})();
